import { ChangeDetectionStrategy, Component, inject, signal, Signal } from '@angular/core';

import { take } from 'rxjs';

import { TranslatePipe } from '@core/i18n-legacy';
import { TellentPositionsDataFacade } from '@core/tellent-positions-logic';
import { PositionDetailsDialogData, TellentPosition } from '@core/tellent-positions-types';
import {
  ButtonComponent,
  ConnectedOverlayDirective,
  DialogBodyComponent,
  DialogComponentI,
  DialogRef,
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
  EmptyStateComponent,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
  OverlayOriginDirective,
  TabComponent,
  TabsComponent,
} from '@core/user-interface-legacy';

import { PositionsDialogsService } from '../services/positions-dialogs.service';

@Component({
  selector: 'tlc-position-details-dialog',
  templateUrl: './position-details-dialog.component.html',
  styleUrls: ['./position-details-dialog.component.less'],
  imports: [
    DialogBodyComponent,
    IconComponent,
    TranslatePipe,
    TabsComponent,
    TabComponent,
    EmptyStateComponent,
    ButtonComponent,
    IconButtonComponent,
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    HeadingComponent,
    OverlayOriginDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [PositionsDialogsService],
})
export class PositionDetailsDialogComponent implements DialogComponentI<
  PositionDetailsDialogData,
  any
> {
  private readonly positionsDataFacade = inject(TellentPositionsDataFacade);
  private readonly positionsDialogsService = inject(PositionsDialogsService);
  private readonly dialogRef = inject(DialogRef);

  protected readonly DropdownWidth = DropdownWidth;

  public positionData: Signal<TellentPosition | null>;

  private positionGuid = signal<string>('');

  public setDialogData(data: PositionDetailsDialogData, triggerUpdate: boolean): void {
    this.positionGuid.set(data.positionGuid);
    this.positionsDataFacade.fetchOne(data.positionGuid);
    this.positionData = this.positionsDataFacade.getPositionById(data.positionGuid);
  }

  public toggleMoreActionsDropdown(dropdown: ConnectedOverlayDirective): void {
    dropdown.open = !dropdown.open;
  }

  public renamePosition(): void {
    this.positionsDialogsService
      .openRenamePositionDialog(this.positionGuid())
      .pipe(take(1))
      .subscribe();
  }

  public deletePosition(): void {
    const position = this.positionData();
    if (!position) return;

    this.positionsDialogsService
      .openDeletePositionDialog(this.positionData()!)
      .pipe(take(1))
      .subscribe(result => {
        if (result.success) this.dialogRef.close(result);
      });
  }
}
